import { Select } from "antd";
import React, { forwardRef } from "react";

const { Option } = Select;

export interface OptionType {
  label: string;
  value: string | number;
}

interface CustomDropdownProps {
  options: OptionType[];
  defaultValue?: OptionType;
  className?: string;
  placeholder?: string;
  modal?: boolean;
  onChange?: any;
  value?: OptionType | OptionType[];
  ref?: any;
  multiple?: boolean;
  showSearch?: boolean;
  filterOption?: (input: string, option: any) => boolean;
  style?:any;
  onPaste?: (e: React.ClipboardEvent) => void;
  onSearch?: (value: string) => void;
  loading?: boolean;
  notFoundContent?: React.ReactNode;
}

const CustomSelect: React.FC<CustomDropdownProps> = forwardRef<any, CustomDropdownProps>(
    ({ options, defaultValue, className, placeholder, modal, onChange, value, multiple, showSearch = false, filterOption, style, onPaste, onSearch, loading, notFoundContent }, ref) => {
      // Determine the popup container based on the `modal` prop
      const getPopupContainer = modal ? () => (document.getElementsByClassName("modal")[0] as HTMLElement) || document.body : undefined;

      return (
          <div onPaste={onPaste}>
              <Select
                  defaultValue={defaultValue}
                  className={className}
                  placeholder={placeholder ? placeholder : "Select"}
                  style={{ width: "100%", ...style }}
                  getPopupContainer={getPopupContainer}
                  labelInValue
                  onChange={(e) => {
                    onChange && onChange(e);
                  }}
                  value={value}
                  mode={multiple ? "multiple" : undefined}
                  showSearch={showSearch}
                  onSearch={onSearch}
                  loading={loading}
                  notFoundContent={notFoundContent}
                  filterOption={
                      // Options already come filtered from the server when onSearch is used
                      onSearch ? false :
                      filterOption ||
                      ((input, option) => {
                        const label = option?.label;
                        return typeof label === "string" && label.toLowerCase().includes(input.toLowerCase());
                      })
                  }
                  ref={ref}
              >
                {options.map((option) => (
                    <Option key={option.value} value={option.value} label={option.label}>
                      {option.label}
                    </Option>
                ))}
              </Select>
          </div>
      );
    }
);

export default CustomSelect;